<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <base-material-card
          icon="mdi-map-check"
          :title="id ? $i18n.t('Edit Fuel Pump - ') + fuelpump.name : $i18n.t('Create Fuel Pump')"
          class="px-3 py-3 small-icon"
        >
          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field :label="$i18n.t('Name')" v-model="fuelpump.name"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <z-zone-select class="purple-input" v-model="fuelpump.zone_id" />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field :label="$i18n.t('Code')" v-model="fuelpump.code"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <z-country-select class="purple-input" v-model="fuelpump.address.country"></z-country-select>
                </v-col>

                <v-col cols="12" md="4">
                  <z-state-select
                    class="purple-input"
                    v-model="fuelpump.address.state"
                    :country="fuelpump.address.country"
                  ></z-state-select>
                </v-col>

                <v-col cols="12" md="4">
                  <z-city-select
                    class="purple-input"
                    v-model="fuelpump.address.city"
                    :state="fuelpump.address.state"
                    :country="fuelpump.address.country"
                  ></z-city-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :label="$i18n.t('Address')"
                    dense
                    v-model="fuelpump.address.addressLine"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-row>
                    <gmap-map
                      :center="center"
                      :zoom="12"
                      style="width:100%;  height: 450px;"
                      ref="mapRef"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="center = m.position"
                      ></gmap-marker>
                    </gmap-map>
                    <div style="width:100%;position: absolute;">
                      <gmap-autocomplete
                        @place_changed="setPlace"
                        :label="$i18n.t('Seach Location')"
                      ></gmap-autocomplete>
                    </div>
                    <div style="top:-275px; width:50px;position:relative; margin:auto">
                      <v-icon style="font-size: 50px;" color="red">mdi-map-marker</v-icon>
                    </div>
                  </v-row>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  fuelpump = {
    name: "",
    address: { country: "", state: "", city: "", addressLine: "" },
  };

  id = null;
  center = { lat: 45.508, lng: -73.587 };
  markers = [];
  places = [];
  currentPlace = null;
  map = null;

  get loading() {
    return common.loading;
  }

  async save() {
    this.fuelpump.address.lat = this.map.getCenter().lat();
    this.fuelpump.address.lon = this.map.getCenter().lng();
    try {
      common.setLoading(true);
      let url = "/api/fuelpump/save";
      if (this.fuelpump._id) {
        url = "/api/fuelpump/edit";
      }
      this.fuelpump = await doPost(url, this.fuelpump);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.fuelpump = await doGet("/api/fuelpump/" + id + "/detail");
      this.id = this.fuelpump._id;
      if (this.fuelpump.address.lat) {
        this.center = {
          lat: this.fuelpump.address.lat,
          lng: this.fuelpump.address.lon,
        };
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
    });
  }

  setPlace(place) {
    this.currentPlace = place;
    this.center = place.geometry.location;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
